/* eslint-disable max-lines */
import dayjs from 'dayjs';
import queryString from 'querystring';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setSubMerchantFilter } from '../../../pages/SubMerchantAggregate/actions';
import { removeDuplicateDataAob } from '../../../utils/builder/common';
import Filter from '../../elements/Filter';
import {
  fetchCities,
  fetchDistricts,
  fetchProvinces,
  fetchRegionals,
  fetchVillages,
} from '../../layouts/PageBase/actions';
import { defaultDateRange, Fields, initialValues } from './fields';
import styles from './styles.scoped.css';

function SubMerchantAggregateFilter() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    local: { filter: values },
  } = useSelector((state) => state.subMerchantAggregate);

  const {
    dataRegionals,
    dataProvinces,
    dataCities,
    dataDistricts,
    dataVillages,
    dataDetailUser: {
      regionalId,
      regionalName,
      provinceId,
      cityId,
      cities,
      districtId,
      villageId,
    },
  } = useSelector((state) => state.pageBase);

  const [selectedTemp, setSelectedTemp] = useState({
    cityId: [],
    districtId: [],
    villageId: [],
  });
  const [valueDate, setValueDate] = useState(defaultDateRange);

  const query = queryString.parse(location.search.replace('?', ''));

  const dropdownData = {
    regional: regionalId
      ? [{ label: regionalName, value: regionalId }]
      : [
        { value: '*', label: 'Semua Regional' },
        ...dataRegionals.filter((item) => item.value !== ''),
      ],
    provinces: [{ value: '*', label: 'Semua Provinsi' }, ...dataProvinces],
    cities: [
      { label: 'Semua Kota/Kab', value: '*' },
      ...dataCities.filter((item) => item.value !== ''),
    ],
    districts: [
      { value: '*', label: 'Semua Kecamatan' },
      ...dataDistricts.filter((item) => item.value !== ''),
    ],
    villages: [
      { value: '', label: 'Semua Kelurahan' },
      ...dataVillages.filter((item) => item.value !== ''),
    ],
  };

  const handleGetAdministrativeArea = (name, params) => {
    const payloadProvince = {
      regional: params?.regional,
      samId: params?.samId,
    };
    const payloadCity = {
      ...payloadProvince,
      provinceId: params?.provinceId,
      sbmId: params?.sbmId,
    };
    const payloadDistrict = {
      ...payloadCity,
      cityId: params?.cityId,
    };
    const payloadVillage = {
      ...payloadDistrict,
      districtId: params?.districtId,
    };

    if (name === 'regional') {
      dispatch(fetchProvinces(payloadProvince));
      dispatch(fetchCities(payloadCity, selectedTemp.cityId));
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
    if (name === 'provinceId') {
      dispatch(fetchCities(payloadCity, selectedTemp.cityId));
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
    if (name === 'cityId') {
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
    if (name === 'districtId') {
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
  };

  const handleChangeValues = ({ name, value }) => {
    let filter = {};
    if (name === 'regional') {
      filter = {
        ...values,
        [name]: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        provinceId: '',
        cityId: '',
        districtId: '',
        villageId: '',
      };
    } else if (name === 'provinceId') {
      filter = {
        ...values,
        regional: regionalId ? JSON.stringify([regionalId]) : values.regional,
        [name]: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        cityId: '',
        districtId: '',
        villageId: '',
      };
    } else if (name === 'cityId') {
      filter = {
        ...values,
        [name]: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        districtId: '',
        villageId: '',
      };
      const originDataTemp = [
        ...selectedTemp.cityId.filter((row) => value.includes(row.value)),
        ...dataCities.filter((row) => value.includes(row.value)),
      ];
      setSelectedTemp((val) => {
        return {
          ...val,
          cityId: removeDuplicateDataAob(originDataTemp, 'value'),
        };
      });
    } else if (name === 'districtId') {
      filter = {
        ...values,
        [name]: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        villageId: '',
      };
      const originDataTemp = [
        ...selectedTemp.districtId.filter((row) => value.includes(row.value)),
        ...dataDistricts.filter((row) => value.includes(row.value)),
      ];
      setSelectedTemp((val) => {
        return {
          ...val,
          districtId: removeDuplicateDataAob(originDataTemp, 'value'),
        };
      });
    } else if (name === 'villageId') {
      filter = {
        ...values,
        [name]: value.length > 0 ? JSON.stringify(value) : '',
      };
      const originDataTemp = [
        ...selectedTemp.villageId.filter((row) => value.includes(row.value)),
        ...dataVillages.filter((row) => value.includes(row.value)),
      ];
      setSelectedTemp((val) => {
        return {
          ...val,
          villageId: removeDuplicateDataAob(originDataTemp, 'value'),
        };
      });
    } else if (name === 'registrationDate') {
      const startDate = value[0] ? dayjs(value[0]).format('YYYY-MM-DD') : '';
      const endDate = value[1] ? dayjs(value[1]).format('YYYY-MM-DD') : '';
      filter = { ...values, [name]: value, startDate, endDate };
    } else {
      filter = { ...values, [name]: value };
    }

    const newQuery = queryString.stringify({ ...query, ...filter });
    navigate(`?${newQuery}`);
    handleGetAdministrativeArea(name, filter);
    dispatch(setSubMerchantFilter(filter));
  };

  const handleReset = () => {
    const filter = {
      ...initialValues,
      regional: regionalId ? JSON.stringify([regionalId]) : '',
      provinceId: provinceId || '',
      cityId: cityId || '',
      districtId: districtId || '',
      villageId: villageId || '',
    };
    dispatch(setSubMerchantFilter(filter));
    setValueDate(defaultDateRange);
    navigate('?');
  };

  const handleSearchFilter = (value, name) => {
    if (regionalId !== undefined) {
      const payloadProvince = {
        regional: regionalId ? JSON.stringify([regionalId]) : query?.regional,
      };

      const payloadCity = {
        ...payloadProvince,
        provinceId: query?.provinceId?.length > 4 ? query?.provinceId : '',
      };
      const payloadDistrict = {
        ...payloadCity,
        cityId: query?.cityId?.length > 4 ? query?.cityId : '',
      };
      const payloadVillage = {
        ...payloadDistrict,
        districtId: query?.districtId?.length > 4 ? query?.districtId : '',
      };
      if (name === 'cities') {
        dispatch(fetchCities(payloadCity, selectedTemp.cityId));
      }
      if (name === 'districts') {
        dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      }
      if (name === 'villages') {
        dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
      }
    }
  };

  useEffect(() => {
    if (regionalId !== undefined) {
      dispatch(fetchRegionals());
      const newQuery = {
        ...values,
        regional: regionalId ? JSON.stringify([regionalId]) : '',
        provinceId: '',
        cityId: '',
        districtId: '',
        villageId: '',
      };
      dispatch(setSubMerchantFilter(newQuery));
      handleGetAdministrativeArea('regional', newQuery);
    }
  }, [regionalId]);

  return (
    <Filter
      className={styles.fields}
      fields={Fields({
        values,
        handleChangeValues,
        dropdownData,
        regionalId,
        provinceId,
        cityId,
        cities,
        handleSearchFilter,
        setValueDate,
        valueDate,
      })}
      handleReset={handleReset}
    />
  );
}

export default SubMerchantAggregateFilter;
